module.exports = __webpack_public_path__ + "static/media/justice.d2afd8ae.svg";